import React from 'react';
import ReactDOM from 'react-dom/client';
import './buildpro.css';
import { initAdapter } from '@/core/db-adapter';
import { loadVerticalModules } from '@/core/vertical-engine';
import App from '@/App';

async function boot(): Promise<void> {
  console.log('[BuildPro] Boot start');
  try {
    await Promise.race([
      initAdapter(),
      new Promise((_, reject) => setTimeout(() => reject(new Error('initAdapter timeout')), 10000)),
    ]);
    await loadVerticalModules();
  } catch (err) {
    const msg = err instanceof Error ? err.message : String(err);
    console.error('[BuildPro] Boot error:', msg);
    const root = document.getElementById('root') ?? document.body;
    root.innerHTML = `<div style="padding:2rem;font-family:system-ui"><h2>BuildPro no pudo iniciarse</h2><p>${msg}</p><button onclick="location.reload()">Reintentar</button></div>`;
    return;
  }
  const rootEl = document.getElementById('root');
  if (!rootEl) return;
  ReactDOM.createRoot(rootEl).render(<React.StrictMode><App /></React.StrictMode>);
  console.log('[BuildPro] Mounted');
}

boot().catch(console.error);
